// Vendor libraries
import { EventEmitter } from '@angular/core';
import { combineLatest, forkJoin, of } from 'rxjs';
import { Store } from '@ngrx/store';
// Services
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { ModelPortfoliosService } from 'ModelPortfolioApp/ts/shared/services/model-portfolios.service';
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Actions
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { addGenerationError, setGeneratingReport, setNotGeneratingReport, setNotGeneratingUnsavedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate/generate.actions';
import { CustomPDFReportType } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-type.enum';
// Constants / Utils
import { CALC_READY_STATES, CalcState } from 'NewAngular/features/components/loaders/status-bar/enums/calc-state.enum';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { LEGACY_REPORT_TYPES } from 'CustomPDFReportsApp/ts/constants';
import { isCustomPDFReport } from 'CustomPDFReportsApp/ts/utils/custom-pdf-report-utils';
import { CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/constants';
import { convertModulesToSaveState } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/utils/custom-pdf-report-builder-utils';
// Selectors
import { generatePostParams, getGeneratingReport, getGeneratingUnsavedReport, getGenerationErrors, getPrimarySecurity, getSecondarySecurity, getSelectedReport, getTearsheetsReportUrl, getYRatingReportUrl, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i2 from "ModelPortfolioApp/ts/shared/services/model-portfolios.service";
import * as i3 from "WatchlistApp/ts/services/watchlists.service";
import * as i4 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function GenerateReportModalComponent_ycn_loading_symbol_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 4);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function GenerateReportModalComponent_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const error_r2 = ctx.$implicit;
    i0.ɵɵproperty("innerText", error_r2);
} }
function GenerateReportModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 5)(2, "div", 6);
    i0.ɵɵtemplate(3, GenerateReportModalComponent_div_3_div_3_Template, 1, 1, "div", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 8)(5, "div", 9)(6, "div", 10);
    i0.ɵɵlistener("click", function GenerateReportModalComponent_div_3_Template_div_click_6_listener() { i0.ɵɵrestoreView(_r1); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.exitModalHandler()); });
    i0.ɵɵtext(7, " OK ");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.errorMessages);
} }
export class GenerateReportModalComponent {
    constructor(customPdfService, modelPortfoliosService, watchlistsService, featureService, store, builderStore) {
        this.customPdfService = customPdfService;
        this.modelPortfoliosService = modelPortfoliosService;
        this.watchlistsService = watchlistsService;
        this.featureService = featureService;
        this.store = store;
        this.builderStore = builderStore;
        this.isOpen = false;
        this.reportType = '';
        this.primarySecurityId = '';
        this.secondarySecurityId = '';
        this.isLoading = false;
        this.errorMessages = [];
        this.postParams = {};
        this.tearsheetsReportURL = null;
        this.yRatingReportURL = null;
        this.reportDataSource = '';
        this.broadcastWizardStepEvent = new EventEmitter();
        this.customPDFReportBuilderStore = null;
        this.reportState = null;
        this.mapStateToComponent = (modalState, builderState // builderState will be null if the current page is not Report Builder.
        ) => {
            this.generationModalsState = modalState;
            if (builderState) {
                this.reportState = builderState.report;
            }
            else if (this.customPDFReportBuilderStore) {
                this.reportState = this.customPDFReportBuilderStore;
            }
            const selectedReport = getSelectedReport(modalState);
            this.isLoading = getGeneratingReport(modalState);
            this.errorMessages = getGenerationErrors(modalState);
            this.postParams = generatePostParams(modalState);
            this.reportId = isCustomPDFReport(selectedReport) ? selectedReport.report_id : undefined;
            this.reportType = selectedReport.report_type;
            this.reportDataSource = selectedReport.data_source;
            this.primarySecurity = getPrimarySecurity(modalState);
            this.secondarySecurity = getSecondarySecurity(modalState);
            this.primarySecurityId = this.primarySecurity.securityId ?? '';
            this.secondarySecurityId = this.secondarySecurity.securityId ?? '';
            this.tearsheetsReportURL = getTearsheetsReportUrl(modalState);
            this.yRatingReportURL = getYRatingReportUrl(modalState);
            // Builder Store needed for Report Generation Without Saving
            this.generateReportConfig = getGeneratingUnsavedReport(modalState);
            if (this.reportState) {
                this.reportParams = {
                    report_type: this.reportState.report_type,
                    report_orientation: this.reportState.report_orientation,
                    name: this.reportState.name || 'Unsaved Report Name', // if the report is new it requires a name for generation
                    description: this.reportState.description,
                    report_footer: this.reportState.report_footer,
                    include_benchmark_default: this.reportState.include_benchmark_default,
                    advanced_options: this.reportState.advanced_options,
                    data_source: this.reportState.data_source,
                    performance_disclosure_footnote: this.reportState.performance_disclosure_footnote,
                    sections: this.reportState.sections || [],
                    remove_report_title_header: this.reportState.remove_report_title_header,
                    language: this.reportState.language,
                };
                this.modules = this.reportState.modules;
            }
        };
        this.storeSubscription = combineLatest([
            this.store.select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY),
            this.builderStore.select((state) => state.reducers ? state.reducers[CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY] : null),
        ]).subscribe(([modalState, builderState]) => this.mapStateToComponent(modalState, builderState));
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        this.isOpen = true;
        this.store.dispatch(setGeneratingReport());
        this.validateAndGenerateReport();
    }
    closeModal() {
        this.isOpen = false;
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    simulateLinkClick(url) {
        if (!url)
            return;
        const link = document.createElement('a');
        link.setAttribute('href', url);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    // External-Calling Items
    generatePdfReport() {
        let serviceResponse;
        const postParams = {
            ...this.postParams,
            custom_security_labels: (this.postParams.custom_security_labels ?? []).filter((l) => l != null),
            generationModalsState: this.generationModalsState,
            reportState: this.reportState,
        };
        if (this.generateReportConfig !== null) {
            serviceResponse = this.customPdfService.generateUnsavedPDFReport(postParams, this.reportParams, convertModulesToSaveState(this.modules), this.generateReportConfig === 'WITHOUT_LEGACY');
        }
        else {
            switch (this.reportType) {
                case CustomPDFReportType.MULTI_SECURITY_COMPARISON:
                case CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW:
                case CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON:
                    if (this.reportId !== undefined) {
                        serviceResponse = this.customPdfService.generatePDFReport(this.reportId, postParams);
                    }
                    break;
                case LEGACY_REPORT_TYPES.TEARSHEET:
                    // Since we have urls in `tearsheetsReportURL`, no need to call report
                    // specific service method
                    const { as_of_date_option, generationModalsState } = postParams;
                    const prepared_for = generationModalsState?.coverPageInfo?.preparedFor || '';
                    const tearsheetsReportURL = `${this.tearsheetsReportURL}&as_of_date_option=${as_of_date_option}&prepared_for=${prepared_for}`;
                    if (this.reportDataSource === 'legacy' &&
                        !this.featureService.userHasFeatures(['exportLegacyData'])) {
                        this.store.dispatch(setNotGeneratingReport());
                        this.store.dispatch(addGenerationError({
                            error: `Unable to generate legacy report`,
                        }));
                    }
                    else if (this.primarySecurity && this.primarySecurity.securityListGroup) {
                        serviceResponse = this.watchlistsService.generateWatchlistPDFReport(this.primarySecurityId, this.reportDataSource, postParams);
                    }
                    else {
                        this.simulateLinkClick(tearsheetsReportURL);
                        // We delay the closing of the Loading spinner for tearsheets to make
                        // it look like all reports take about the same amount of time to render.
                        setTimeout(() => {
                            this.store.dispatch(setNotGeneratingReport());
                            this.exitModalHandler();
                        }, 1000);
                    }
                    break;
                case LEGACY_REPORT_TYPES.Y_RATING:
                    // Since we have urls in 'yRatingReportURL`, no need to call report
                    // specific service method
                    if (this.reportDataSource === 'legacy' &&
                        !this.featureService.userHasFeatures(['exportLegacyData'])) {
                        this.store.dispatch(setNotGeneratingReport());
                        this.store.dispatch(addGenerationError({
                            error: `Unable to generate legacy report`,
                        }));
                    }
                    else {
                        this.simulateLinkClick(this.yRatingReportURL);
                        setTimeout(() => {
                            this.store.dispatch(setNotGeneratingReport());
                            this.exitModalHandler();
                        }, 1000);
                    }
                    break;
                default:
                    if (this.reportId !== undefined) {
                        this.store.dispatch(addGenerationError({
                            error: `Unknown reportType: ${this.reportType} encountered.`,
                        }));
                    }
            }
        }
        // If we rendered a tearsheet, exit here
        if (!serviceResponse)
            return;
        serviceResponse.subscribe({
            next: (rsp) => {
                const renderedReportUrl = rsp.report_url;
                const renderedZipUrl = rsp.zip_url;
                if (renderedReportUrl) {
                    this.simulateLinkClick(renderedReportUrl);
                    // Add delay for 'both' export type to allow multiple downloads
                    setTimeout(() => {
                        if (renderedZipUrl) {
                            this.simulateLinkClick(renderedZipUrl);
                        }
                    }, 1000);
                }
                else if (renderedZipUrl) {
                    this.simulateLinkClick(renderedZipUrl);
                }
                else {
                    this.setNotGeneratingReportWithError('There was an error rendering your report. Please try again or contact support.');
                }
                this.store.dispatch(setNotGeneratingReport());
                this.store.dispatch(setNotGeneratingUnsavedReport());
                this.exitModalHandler();
            },
            error: (e) => {
                let errorMessage;
                switch (e.status) {
                    case 400:
                        errorMessage =
                            e.error?.error_message || 'An unknown error occurred. Please try again or contact support.';
                        break;
                    case 404:
                        errorMessage = 'Security not available. Please try again or contact support.';
                        break;
                    case 403:
                        if (e?.data?.includes('no pages')) {
                            errorMessage =
                                'The requested report contains no pages. Please try again or contact support.';
                        }
                        else {
                            errorMessage =
                                e?.error?.error_message || 'Permission Denied. Please try again or contact support.';
                        }
                        break;
                    case 409:
                        errorMessage =
                            'Model Portfolio is currently unavailable or in a calculating state. ' +
                                'Please try again or contact support.';
                        break;
                    case 424:
                        const expected_error_messages = [
                            'Unable to generate report for watchlist containing more than 45 securities',
                        ];
                        const scenario_error = 'Selected scenario is not valid.';
                        if ((e.error || '').startsWith(scenario_error)) {
                            errorMessage = scenario_error;
                        }
                        else if (expected_error_messages.includes(e.error || '')) {
                            errorMessage = e.error;
                        }
                        else {
                            // Upstream error from AWS; this will be logged to Datadog.
                            errorMessage =
                                'There was an error rendering your report. Please try again or contact support.';
                        }
                        break;
                    case 503:
                        errorMessage = 'Report size exceeds the limit. Please adjust your selections to proceed.';
                        break;
                    default:
                        errorMessage = 'An unknown error occurred. Please try again or contact support.';
                        break;
                }
                this.setNotGeneratingReportWithError(errorMessage);
            },
        });
    }
    validateModelPortfolioStatus() {
        // Pull out any model portfolio IDs and check to see if any are in calculating state
        const securityIds = [this.primarySecurityId, this.secondarySecurityId].filter((securityId) => !!securityId);
        const modelPortfolioIds = securityIds.filter((securityId) => securityId.split(':')[0] === 'P');
        // If either of the securities is a Model Portfolio, return status MODEL_PORTFOLIO_STATE_AVAILABLE
        if (modelPortfolioIds.length === 0) {
            return of([{ status: CalcState.STATE_AVAILABLE }]);
        }
        const securityObservables = modelPortfolioIds.map((securityId) => this.checkModelPortfolioStatus(securityId));
        return forkJoin(securityObservables);
    }
    validateAndGenerateReport() {
        this.validateModelPortfolioStatus().subscribe({
            next: (securityData) => {
                const isValid = securityData.every((s) => CALC_READY_STATES.includes(s.status));
                if (isValid) {
                    this.generatePdfReport();
                }
                else {
                    this.setNotGeneratingReportWithError('Model Portfolio is currently unavailable or in a calculating state. ' +
                        'Please try again or contact support.');
                }
            },
            error: () => this.setNotGeneratingReportWithError('An unknown error occurred. Please try again or contact support.'),
        });
    }
    setNotGeneratingReportWithError(error) {
        this.store.dispatch(setNotGeneratingReport());
        this.store.dispatch(setNotGeneratingUnsavedReport());
        this.store.dispatch(addGenerationError({ error }));
    }
    /**
     * Checks the report's securities (e.g. `securityId`, `primarySecurityId`,
     * `secondarySecurityId`) to ensure they are ready to be rendered. This should only
     * return `false` if a ModelPortfolio is in a calculating state.
     *
     * @returns Observable<ItemStatus>
     */
    checkModelPortfolioStatus(securityId) {
        // If we have a non-Model Portfolio security, simply return `true`
        const securityObjectId = securityId.split(':')[1];
        return this.modelPortfoliosService.getModelPortfolioStatus(securityObjectId);
    }
}
GenerateReportModalComponent.ɵfac = function GenerateReportModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GenerateReportModalComponent)(i0.ɵɵdirectiveInject(i1.CustomPDFReportService), i0.ɵɵdirectiveInject(i2.ModelPortfoliosService), i0.ɵɵdirectiveInject(i3.WatchlistsService), i0.ɵɵdirectiveInject(i4.FeatureService), i0.ɵɵdirectiveInject(i5.Store), i0.ɵɵdirectiveInject(i5.Store)); };
GenerateReportModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenerateReportModalComponent, selectors: [["ycn-generate-report-modal"]], inputs: { customPDFReportBuilderStore: "customPDFReportBuilderStore" }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 4, vars: 4, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [3, "loaderMessage", 4, "ngIf"], [4, "ngIf"], [3, "loaderMessage"], [1, "modal-body"], [1, "modal-section"], ["class", "feedback feedback-invalid", 3, "innerText", 4, "ngFor", "ngForOf"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-primary", 3, "click"], [1, "feedback", "feedback-invalid", 3, "innerText"]], template: function GenerateReportModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function GenerateReportModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function GenerateReportModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, GenerateReportModalComponent_ycn_loading_symbol_2_Template, 1, 1, "ycn-loading-symbol", 2)(3, GenerateReportModalComponent_div_3_Template, 8, 1, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessages.length !== 0);
    } }, dependencies: [i6.NgForOf, i6.NgIf, i7.LoadingSymbolComponent, i8.ModalBaseComponent, i9.SimpleModalHeaderComponent], encapsulation: 2 });
